import {Box, Paper, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {useMemo} from "react";
import CartSummaryList from "@/components/Cart/CartSummaryList.tsx";
import TotalRow from "@/components/Cart/TotalRow.tsx";
import {useUser} from "@/components/Providers/JWTProvider.tsx";

type Props = {
    totalCost: number;
    cartIsEmpty: boolean;
    errorMessage: string;
    isPayButtonDisabled?: boolean;
    cartPage: boolean;
    triggerPayment?: () => void;
};

export const CartPanel = ({
    totalCost,
    cartIsEmpty,
    errorMessage,
    isPayButtonDisabled,
    triggerPayment,
    cartPage,
}: Props) => {
    const {isEmployee, isStudentOrCM, user} = useUser();
    const studentDisplay = useMemo(() => {
        if (isEmployee) {
            return `${user.employeeID} - ${user.displayName}`;
        }
        if (isStudentOrCM) {
            const name = `${user?.nameFirst} ${user?.nameLast}`;
            if (user.userType === "guest_user") {
                return name;
            }
            return `${user.studentId} - ${name}`;
        }
        return "";
    }, [isEmployee, isStudentOrCM, user]);

    return (
        <Box
            sx={{
                width: {xs: "100%", md: "40%"},
                pl: {md: 2},
            }}
        >
            <Paper
                sx={{
                    position: "sticky",
                    top: 16,
                    borderRadius: 2,
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        p: 2,
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        bgcolor: "background.default",
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: {
                            xs: "column",
                            sm: "row",
                        },
                    }}
                >
                    <Typography variant="h6">Cart Summary</Typography>
                    <Grid
                        size={{xs: 12, sm: 6}}
                        sx={{
                            textAlign: {xs: "left", sm: "right"},
                            pr: 2,
                            py: {xs: 1, sm: 0},
                            marginY: "auto",
                        }}
                    >
                        {studentDisplay}
                    </Grid>
                </Box>
                <Box
                    sx={{
                        p: 2,
                    }}
                >
                    <CartSummaryList />
                    <TotalRow
                        totalCost={totalCost}
                        cartIsEmpty={cartIsEmpty}
                        errorMessage={errorMessage}
                        isPayButtonDisabled={isPayButtonDisabled}
                        triggerPayment={triggerPayment}
                        cartPage={cartPage}
                    />
                </Box>
            </Paper>
        </Box>
    );
};
